import { render, staticRenderFns } from "./EditV2Product.vue?vue&type=template&id=488da1c0&"
import script from "./EditV2Product.vue?vue&type=script&lang=js&"
export * from "./EditV2Product.vue?vue&type=script&lang=js&"
import style0 from "./EditV2Product.vue?vue&type=style&index=0&id=488da1c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports